import { cacheActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    immigrationInfo: {},
    previousImmigrationInfo: {},
    previousSSNs: {},
    ssns: {},
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case cacheActionTypes.CACHE_SSNS:
            return {
                ...state,
                ssns: action.ssns
            };
        case cacheActionTypes.CACHE_PREVIOUS_SSNS:
            return {
                ...state,
                previousSSNs: action.ssns
            };
        case cacheActionTypes.UPDATE_CACHED_SSN:
            return {
                ...state,
                ssns: { ...state.ssns, [action.applicantGuid]: action.ssn }
            };
        case cacheActionTypes.CACHE_IMI:
            return {
                ...state,
                immigrationInfo: action.imi
            };
        case cacheActionTypes.CACHE_PREVIOUS_IMI:
            return {
                ...state,
                previousImmigrationInfo: action.imi
            };
        case cacheActionTypes.UPDATE_CACHED_IMI:
            return {
                ...state,
                immigrationInfo: {
                    ...state.immigrationInfo,
                    [action.applicantGuid]: {
                        ...state.immigrationInfo[action.applicantGuid],
                        ...action.imi
                    }
                }
            };
        case cacheActionTypes.REMOVE_CACHED_DATA:
            delete state.ssns[action.applicantGuid];
            delete state.immigrationInfo[action.applicantGuid];
            return state;
        case cacheActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};